<header>
  <nav class="navbar navbar-expand-lg">
    <div class="container">
      <div>
        <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbar-content">
          <span class="fa fa-bars"></span>
        </button>

        <a class="navbar-brand" routerLink="/"><img src="assets/images/new-theme/logo-old.png"
            alt="Logo | Ghrcacsn" /></a>
      </div>
      <div class="main-navbar collapse navbar-collapse" id="navbar-content">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item dropdown">
            <a class="dropdown-toggle" href="Javascript:void(0);" data-toggle="dropdown">
              About
            </a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" routerLink="/about-institute">About Institute</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/about-rgi">About Raisoni Group</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/vision-mission">Vision and Mission</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/core-values">Core Values</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/chairman-message">Chairman's Message</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/principal-message">Principal's Message</a>
              </li>
              <!-- <li><a class="dropdown-item" routerLink="/rti-act">RTI</a> -->
              <li>
                <a class="dropdown-item" routerLink="/governing-body">
                  Governing body
                </a>
              </li>
              <li>
                <a class="dropdown-item"
                  href="https://drive.google.com/file/d/12xnguNBZCBq0chFRcStjkVkZaPUhlGsf/view?usp=sharing"
                  target="_blank">Oraganogram
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="dropdown-toggle" href="Javascript:void(0);" data-toggle="dropdown">
              Admission
            </a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" routerLink="/admission-overview">Admission Overview</a>
              </li>
              <!-- <li><a class="dropdown-item" href="https://ghrccst.raisoni.net/prospectus/index.html"</li>
                            target="_blank">Prospectus</a> -->
              <!-- <li><a class="dropdown-item" routerLink="/student-scholarship">Student Scholarship</a></li> -->
              <!-- <li><a class="dropdown-item" routerLink="/rgi-scholarship">RGI Scholarship</a> -->
              <!-- <li><a class="dropdown-item"
                                    href="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/pdf/meritorious-scholarship-policy.pdf"
                                    target="_blank">RGI Scholarship</a></li> -->
              <li>
                <a class="dropdown-item" routerLink="/admission-helpline">Admission Helpline</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/account-details">Account Details</a>
              </li>
              <li><a class="dropdown-item" routerLink="/faqs">FAQs</a></li>
              <li>
                <a class="dropdown-item" routerLink="/city-office">City Office</a>
              </li>
              <!-- <li><a class="dropdown-item" routerLink="/online-fees-payment">Online Fees Payment and NEFT
                                    Bank Detail</a></li> -->
              <!-- <li><a class="dropdown-item" routerLink="/fees-structures">fees structure</a></li> -->
            </ul>
          </li>
          <li class="nav-item dropdown dropdown-mega position-static">
            <a href="Javascript:void(0);" data-toggle="dropdown" class="nav-link dropdown-toggle">
              Courses
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <div class="mega-content">
                <div class="container-fluid">
                  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-2">
                    <div class="col">
                      <h6 class="mt-3">Courses</h6>
                      <ul>
                        <li>
                          <a class="dropdown-item" routerLink="/bba-colleges-nagpur">Bachelor of Business
                            Administration[BBA]</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/bachelor-of-computer-application">Bachelor in Computer
                            application [BCA]</a>
                        </li>

                        <li>
                          <a class="dropdown-item" routerLink="/bcca-colleges-nagpur">B.Com. (Computer Application)
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/bcom-honors">
                            B.Com (Honors)</a>
                        </li>

                        <li>
                          <a class="dropdown-item" routerLink="/bsc-finance">B.Sc. Finance</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/bsc-economics">B.Sc. Economics</a>
                        </li>
                        <li>
                          <a class="dropdown-item" href="javascript:void(0);">B.Sc. Information Technology</a>
                        </li>
                      </ul>
                    </div>
                    <div class="col">
                      <ul>
                        <li>
                          <a class="dropdown-item mt-5" href="javascript:void(0);">B.Sc. Artificial Intelligence</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/bsc-data-science">BSc Data Science</a>
                        </li>
                        <li>
                          <a class="dropdown-item" href="javascript:void(0);">BSc (Honours) in Computer Science
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/ba-honors-eonomics">BA (Honors) / Economics
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" href="javascript:void(0);">BA Digital Marketing & Social Media
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/msc-computer-science">M.Sc. Computer Science
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/master-of-computer-management">Master of Commerce
                            (Computer Management) [MCM]</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="dropdown-toggle" href="Javascript:void(0);" data-toggle="dropdown">
              Committee</a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" routerLink="/institute-anti-ragging-committee">Institute Anti Ragging
                  Committee</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/anti-ragging-squad">Anti Ragging Squad
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/grievance-redressal-committee">Grievance Redressal Committee
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/woman-development-cell">Woman Development Cell</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/anti-sexual-harassment-grievance-cell">Anti Sexual Harassment
                  Grievance Cell
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/training-and-placement-cell-and-three-cell">Training and Placement
                  Cell and III cell</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/internal-complaint-committee">Internal Complaint Committee</a>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="dropdown-toggle" href="Javascript:void(0);" data-toggle="dropdown">Placement</a>
            <ul class="dropdown-menu">
              <a class="dropdown-item" routerLink="/placement-process">Placement Process</a>
              <a class="dropdown-item" routerLink="/placement-team">Placement Team</a>
              <a class="dropdown-item"
                href="https://drive.google.com/file/d/1rbdqnrFCTiRqjT3dvUCWbT7cx14CloAd/view?usp=sharing"
                target="_blank">Placement Policy</a>
              <a class="dropdown-item" routerLink="/placement-details">Placement Details</a>
              <a class="dropdown-item" routerLink="/internship">Internship</a>
              <a class="dropdown-item" routerLink="/our-recruiters">Our Recruiters</a>
              <a class="dropdown-item" routerLink="/testimonials">Testimonials</a>
              <a class="dropdown-item" routerLink="/rocs">ROCS</a>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="dropdown-toggle" href="Javascript:void(0);" data-toggle="dropdown">
              Campus Life</a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" routerLink="/tm-express">TM Express</a>
              </li>
              <li>
                <a class="dropdown-item" href="javascript:void(0);">NSS</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/student-life">Student Life</a>
              </li>
              <li><a class="dropdown-item" routerLink="/sports">Sports</a></li>
              <li>
                <a class="dropdown-item" routerLink="/library">Library</a>
              </li>
              <li><a class="dropdown-item" routerLink="/labs">Labs</a></li>
              <li>
                <a class="dropdown-item" routerLink="/latest-news">Latest News</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/student-speak">Student Speak</a>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="dropdown-toggle" href="Javascript:void(0);" data-toggle="dropdown">
              Alumni</a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" routerLink="/about-alumni">About Alumni</a>
              </li>
              <li>
                <a class="dropdown-item" href="https://alumnii.raisoni.net/account" target="_blank">Alumni
                  Registration</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/alumni-speak">Alumni Speak</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/alumni-events">Alumni Events</a>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="dropdown-toggle" href="Javascript:void(0);" data-toggle="dropdown">
              Event</a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" routerLink="/events-new">Events</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/cocurricular-events">Co-Curricular Events</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/extra-curricular-events">Extra Curricular Events</a>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="dropdown-toggle" href="https://currentopenings.raisoni.net/" target="_blank">Current Openings</a>
          </li>
          <li class="nav-item dropdown">
            <a class="dropdown-toggle" routerLink="/contact">Contact</a>
          </li>
          <li class="nav-item dropdown dropdown-mega-1 position-static">
            <a href="Javascript:void(0);" data-toggle="dropdown" data-bs-auto-close="outside"
              class="nav-link dropdown-toggle">
              <i class="fa fa-bars"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <div class="mega-content">
                <ul>
                  <!-- <li>
                    <a
                      href="https://script.google.com/macros/s/AKfycbzbSA3lYjRsPtHPdQoQw8mhJNWsUdYCDvx6E-S7YcJpoIwt5jSVEixk8VTHNPyuhviwFQ/exec"
                      target="_blank"
                      class="dropdown-item"
                      ><strong>Current Openings</strong></a
                    >
                  </li> -->
                  <li>
                    <a class="dropdown-item" routerLink="/mandatory-disclosure">Mandatory disclosure</a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="https://privilege.raisoni.net/login" target="_blank">Raisoni
                      Privilege
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" routerLink="/blogs">Blogs</a>
                  </li>
                  <li><a class="dropdown-item" routerLink="/iqac">IQAC</a></li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
